
<div class="py-2 spreadsheet-container">
  <error [error]="error"></error>
  <nav class="nav"><a class="nav-link rounded-0 text-center" href="javascript:void(0)" [ngClass]="mainPage === &quot;mainDetails&quot; ? &quot;active-tab&quot; : &quot;&quot;" (click)="mainPage = &quot;mainDetails&quot;" style="width: 208px;"><span>MAIN DETAILS</span></a><a class="nav-link rounded-0 text-center" *ngIf="enableDartOffers" href="javascript:void(0)" [ngClass]="mainPage === &quot;dartOffers&quot; ? &quot;active-tab&quot; : &quot;&quot;" (click)="mainPage = &quot;dartOffers&quot;" style="width: 208px;"><span>DART OFFERS</span></a><a class="nav-link rounded-0 text-center" href="javascript:void(0)" [ngClass]="mainPage === &quot;govDetails&quot; ? &quot;active-tab&quot; : &quot;&quot;" (click)="mainPage = &quot;govDetails&quot;" style="width: 208px;"><span>GOVERNMENTAL DETAILS</span></a><a class="flex-fill align-items-center d-flex justify-content-end border-none-important small" *ngIf="_purchaseOrder.purchaseOrderNumber.trim().length">
      <div class="text-muted">Customer PO No.<b class="pl-1 text-body">{{ _purchaseOrder.purchaseOrderNumber}}</b></div></a></nav>
  <div [hidden]="mainPage !== &quot;mainDetails&quot;">
    <table class="table table-bordered">
      <thead class="thead-light">
        <tr>
          <td class="required-add-asterisk" style="background: #F2FAFD; color: #a5a5a5; font-weight: normal; border-bottom-width: 1px;">Customer PO Number</td>
          <td class="required-add-asterisk" style="background: #F2FAFD; color: #a5a5a5; font-weight: normal; border-bottom-width: 1px;">Customer PO Description</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="align-middle">
            <input class="form-control" [(ngModel)]="_purchaseOrder.purchaseOrderNumber" name="purchaseOrderName{{_purchaseOrderIndex}}" id="purchaseOrderName{{_purchaseOrderIndex}}" placeholder="Enter PO Number" [disabled]="isDisabled || readOnlyInputs ||_purchaseOrder?.perSignedSOW || _purchaseOrder?.pendingPO" (change)="poInputTextValueChanged()">
          </td>
          <td class="align-middle form-inline border-0">
            <input class="form-control flex-grow-1" [(ngModel)]="_purchaseOrder.purchaseOrderDescription" name="purchaseOrderDescription{{_purchaseOrderIndex}}" id="purchaseOrderDescription{{_purchaseOrderIndex}}" placeholder="Enter PO Description" [disabled]="isDisabled || readOnlyInputs" (change)="poInputTextValueChanged()">
            <button class="ml-2 btn btn-sm btn-outline-danger oi oi-trash" *ngIf="selectedPurchaseOrders.length &gt; 2" type="button" (click)="removePurchaseOrder(_purchaseOrderIndex, _purchaseOrder)"></button>
          </td>
        </tr>
        <tr *ngIf="showSelectPOLink">
          <td class="text-center pt-1 pb-1" colspan="2">
            <button class="btn btn-link" type="button" [disabled]="purchaseOrdersITSM &gt; 0 || isDisabled" [ngClass]="{'disabled': purchaseOrdersITSM &gt; 0}" href="javascript:void(0)" (click)="selectPurchaseOrderDialog()">Select Purchase Order</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="enableDartOffers" [hidden]="mainPage !== &quot;dartOffers&quot;">
    <table class="table table-bordered">
      <thead class="thead-light">
        <tr>
          <th style="background: #F2FAFD; color: #a5a5a5; font-weight: normal;border-bottom-width: 1px;">DART Offers</th>
          <th style="background: #F2FAFD; color: #a5a5a5; font-weight: normal;border-bottom-width: 1px;">Offer Description</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let dartOffer of _purchaseOrder.dartOffers; let i = index">
          <td>
            <div class="col-12">
              <input class="form-control" [(ngModel)]="dartOffer.offerNumber" id="offerNumber{{i}}" name="offerNumber{{i}}" [disabled]="true">
            </div>
          </td>
          <td>
            <div class="col-12">
              <input class="form-control" [(ngModel)]="dartOffer.offerDescription" id="offerDescription{{i}}" name="offerDescription{{i}}" [disabled]="true">
            </div>
          </td>
        </tr>
        <tr>
          <td class="text-center pt-1 pb-1" colspan="2">
            <button class="btn btn-link" type="button" href="javascript:void(0)" (click)="selectPurchaseOrderOffersDialog()">Select Offer(s) to Purchase Order</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div [hidden]="mainPage !== &quot;govDetails&quot;">
    <table class="table table-bordered">
      <thead class="thead-light">
        <tr>
          <td class="required-add-asterisk" style="background: #F2FAFD; color: #a5a5a5; font-weight: normal; border-bottom-width: 1px;">Customer PO Item Number</td>
        </tr>
      </thead>
      <tbody>
        <td>
          <input class="form-control" id="itemNumber" [(ngModel)]="itemNumber" name="itemNumber" [disabled]="true">
        </td>
      </tbody>
    </table>
  </div>
</div>